import Vue from 'vue';
import VueRecaptcha from 'vue-recaptcha';
import _ from 'lodash';

Vue.mixin({
  data() {
    return {
      confirm: false,
      customerStep: '1',
      customerName: '',
      customerEmail: '',
      customerPhone: '',
      allowNotifications: true,
      imageUrl: this.headerBackground,
      tagCode: '',
      recaptchaResponse: null,
      morePhotosExampleClasses: {
        1: '',
        2: '',
        3: '',
      }
    };
  },
  components: {
    VueRecaptcha,
  },
  computed: {
    modalParams() {
      return {
        clickToClose: false,
        scrollable: true,
        adaptive: true,
        width: '100%',
        maxWidth: 625,
        height: 'auto',
      };
    },
    albumThumbnail() {
      if (this.album) {
        return this.album.primary_photo
            ? this.album.primary_photo.medium_photo
            : this.album.first_photo
                ? this.album.first_photo.medium_photo
                : false;
      }

      return false;
    },
    recaptchaKey() {
      return process.env.VUE_APP_RECAPTCHA_KEY;
    },
  },
  watch: {
    '$route'() {
      if (localStorage.getItem('cookies')) {
        this.closeModal();
      }
    },
  },
  methods: {
    blurBackground() {
      document.getElementById('app')
      && document.getElementById('app').classList.add('-blur');
    },
    unBlurBackground() {
      document.getElementById('app')
      && document.getElementById('app').classList.remove('-blur');
    },
    showSelectMorePhotosModal() {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div class="custom-modal custom-modal--simple">
            <div class="custom-modal-content">
              <div class="custom-modal-content-inner">
                <h1 class="text-center">{{ $t('select_more_photos') }}</h1>
                <p class="text-center">{{ $t('descriptions.select_more_photos') }}</p>
                <div class="more-photos-examples">
                  <div :class="['more-photos-example-1', morePhotosExampleClasses[1]]">
                    <svg class="more-photos-example-checked" width="40" height="40" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4 24C4 12.96 12.96 4 24 4C35.04 4 44 12.96 44 24C44 35.04 35.04 44 24 44C12.96 44 4 35.04 4 24ZM10 24L20 34L38 16L35.18 13.16L20 28.34L12.82 21.18L10 24Z"/>
                    </svg>
                    <svg class="more-photos-example-hover" width="18px" height="19px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path d="M16,0 L2,0 C0.89,0 0,0.9 0,2 L0,16 C0,17.1 0.89,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 Z M16,16 L2,16 L2,2 L16,2 L16,16 Z M8,14 L10,14 L10,10 L14,10 L14,8 L10,8 L10,4 L8,4 L8,8 L4,8 L4,10 L8,10 L8,14 Z"></path>
                    </svg>
                  </div>
                  <div :class="['more-photos-example-2', morePhotosExampleClasses[2]]">
                    <svg class="more-photos-example-checked" width="40" height="40" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4 24C4 12.96 12.96 4 24 4C35.04 4 44 12.96 44 24C44 35.04 35.04 44 24 44C12.96 44 4 35.04 4 24ZM10 24L20 34L38 16L35.18 13.16L20 28.34L12.82 21.18L10 24Z"/>
                    </svg>
                    <svg class="more-photos-example-hover" width="18px" height="19px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path d="M16,0 L2,0 C0.89,0 0,0.9 0,2 L0,16 C0,17.1 0.89,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 Z M16,16 L2,16 L2,2 L16,2 L16,16 Z M8,14 L10,14 L10,10 L14,10 L14,8 L10,8 L10,4 L8,4 L8,8 L4,8 L4,10 L8,10 L8,14 Z"></path>
                    </svg>
                  </div>
                  <div :class="['more-photos-example-3', morePhotosExampleClasses[3]]">
                    <svg class="more-photos-example-checked" width="40" height="40" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4 24C4 12.96 12.96 4 24 4C35.04 4 44 12.96 44 24C44 35.04 35.04 44 24 44C12.96 44 4 35.04 4 24ZM10 24L20 34L38 16L35.18 13.16L20 28.34L12.82 21.18L10 24Z"/>
                    </svg>
                    <svg class="more-photos-example-hover" width="18px" height="19px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path d="M16,0 L2,0 C0.89,0 0,0.9 0,2 L0,16 C0,17.1 0.89,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 Z M16,16 L2,16 L2,2 L16,2 L16,16 Z M8,14 L10,14 L10,10 L14,10 L14,8 L10,8 L10,4 L8,4 L8,8 L4,8 L4,10 L8,10 L8,14 Z"></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-modal-footer">
              <a href="#" v-if="isMobile" @click.prevent="acceptSelectMoreInfo" class="btn btn-success btn-shadow">
                <span class="material-icon icon-done"></span>
              </a>
              <a href="#" v-else @click.prevent="acceptSelectMoreInfo" class="btn btn-link text-uppercase">
                {{ $t('ok_i_understand') }}
              </a>
            </div>
          </div>`,
      }, {}, {...this.modalParams, maxWidth: 670});
    },
    createNewTab(pageName) {
      const win = window.open(this.i18nLink(`/${pageName}`), '_blank');
      win.focus();
    },
    showConfirmModal() {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div class="custom-modal custom-modal--simple">
            <div class="custom-modal-content" :class="{'-red': !confirm}">
              <div class="custom-modal-content-inner">
                <div :class="{'px-4': isMobile}">
                  <b-form-checkbox v-model="confirm">
                    {{ $t('tc_prefix') }}
                    <a href="#" @click.prevent="createNewTab('terms-of-use')">
                      {{ $t('terms_and_conditions') }}</a>
                    {{ $t('tc_glue') }}
                    <a href="#" @click.prevent="createNewTab('privacy-policy')">
                      {{ $t('privacy_policy') }}</a>
                    {{ $t('tc_suffix') }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <div class="custom-modal-footer">
              <template v-if="isMobile">
                  <a href="#" v-if="isMobile" @click.prevent="closeModal" class="btn btn-light btn-shadow">
                      <span class="material-icon icon-clear"></span>
                  </a>
                  <a href="#" @click.prevent="goToCheckout" class="btn" :class="confirm ? 'btn-success btn-shadow' : 'btn-disabled'" :disabled="!confirm">
                      <span class="material-icon icon-done"></span>
                  </a>
              </template>
              <template v-else>
                <a href="#" @click.prevent="goToCheckout" class="btn btn-icon-right text-uppercase" :class="confirm ? 'btn-success btn-shadow' : 'btn-disabled'" :disabled="!confirm">
                  {{ $t('confirm_&_continue') }}
                  <span class="material-icon icon-keyboard_arrow_right"></span>
                </a>
                <a href="#" @click.prevent="closeModal" class="btn btn-link text-uppercase">
                  {{ $t('cancel_&_close') }}
                </a>
              </template>
            </div>
          </div>`,
      }, {}, {...this.modalParams, maxWidth: 660});
    },
    showConfirmAddressModal(customerDetails) {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div class="custom-modal custom-modal--simple">
            <div class="custom-modal-content">
              <div class="custom-modal-content-inner">
                <div :class="{'px-4': isMobile}">
                  {{ $t('order_will_be_shipped_to_this_address') }}:<br>
                  <strong v-if="customerDetails">
                    {{ customerDetails.address }}<br>
                    {{ customerDetails.zip }} {{ customerDetails.city }},
                    {{ customerDetails.country }}
                  </strong><br>
                  {{ $t('confirm_address_is_correct_or_edit') }}
                </div>
              </div>
            </div>
            <div class="custom-modal-footer">
              <template v-if="isMobile">
                  <a href="#" v-if="isMobile" @click.prevent="closeModal" class="btn btn-light btn-shadow">
                      <span class="material-icon icon-create"></span>
                  </a>
                  <a href="#" @click.prevent="confirmAddress" class="btn btn-success btn-shadow">
                      <span class="material-icon icon-done"></span>
                  </a>
              </template>
              <template v-else>
                <a href="#" @click.prevent="confirmAddress" class="btn btn-success btn-shadow btn-icon-right text-uppercase">
                  {{ $t('confirm_&_continue') }}
                  <span class="material-icon icon-keyboard_arrow_right"></span>
                </a>
                <a href="#" @click.prevent="closeModal" class="btn btn-link text-uppercase">
                  {{ $t('edit') }}
                </a>
              </template>
            </div>
          </div>`,
        props: ['customerDetails'],
      }, {customerDetails}, {...this.modalParams, maxWidth: 670});
    },
    showExistingEmailModal(email, order) {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div class="custom-modal">
            <div class="custom-modal-content -blue" :class="{'custom-modal-content--mobile': isMobile}">
              <div class="custom-modal-content-inner">
                <div class="custom-modal-content-inner__existing-email">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24Zm0-2.33A9.68,9.68,0,1,0,2.32,12,9.64,9.64,0,0,0,12,21.67Z"/>
                    <path d="M10.45,15.88V12.79h-.13c-.19,0-.37,0-.55,0a.55.55,0,0,1-.47-.52c0-.39,0-.78,0-1.17a.58.58,0,0,1,.62-.62h3a.59.59,0,0,1,.66.66c0,1.53,0,3.07,0,4.61,0,.13,0,.17.17.16s.25,0,.38,0a.58.58,0,0,1,.62.6q0,.56,0,1.11a.59.59,0,0,1-.63.61H9.92a.58.58,0,0,1-.62-.6c0-.37,0-.75,0-1.12a.57.57,0,0,1,.61-.6Z"/>
                    <path d="M12,9.38a2,2,0,1,1,2-2A2,2,0,0,1,12,9.38Z"/>
                  </svg>
                  <span>{{ $t('existing_email_text', {email}) }}</span>
                </div>
              </div>
            </div>
            <div class="custom-modal-footer" :class="{'custom-modal-footer--mobile': isMobile}">
              <a href="#" @click.prevent="goToLoginCheckout" class="btn btn-icon-right btn-success btn-shadow text-uppercase">
                {{ $t('sign_in_with_email') }}
                <span class="material-icon icon-keyboard_arrow_right"></span>
              </a>
              <a href="#" @click.prevent="continueAsGuest(order)" class="btn btn-link text-uppercase">
                {{ $t('continue_as_guest') }}
              </a>
            </div>
          </div>`,
        props: ['email', 'order'],
      }, {email, order}, {...this.modalParams, maxWidth: 680});
    },
    showCouponModal() {
      this.blurBackground();

      this.$bvToast.hide();
      this.$modal.show({
        template: `
          <div class="custom-modal">
            <div class="custom-modal-content">
              <div class="custom-modal-content-inner">
                <h1 class="text-center">{{ $t('your_coupon') }}</h1>
                <p class="text-center">{{ $t('your_coupon_description') }}</p>
                <coupon/>
              </div>
            </div>
            <div class="custom-modal-footer">
              <a href="#" @click.prevent="closeCouponModal" class="btn btn-link text-uppercase mx-auto">
                {{ $t('close') }}
              </a>
            </div>
          </div>`,
      }, {}, {...this.modalParams, maxWidth: 930});
    },
    showCloseCheckoutModal() {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div class="custom-modal custom-modal--simple">
            <div class="custom-modal-content">
              <div class="custom-modal-content-inner">
                <p v-html="$t(isMobile ? 'cancel_checkout_text_mobile' : 'cancel_checkout_text')" :class="{'text-center': isMobile}"></p>
              </div>
            </div>
            <div class="custom-modal-footer">
              <template v-if="isMobile">
                <a href="#" @click.prevent="closeModal" class="btn btn-light btn-shadow">
                  <span class="material-icon icon-clear"></span>
                </a>
                <a href="#" @click.prevent="closeCheckout" class="btn btn-success btn-shadow">
                  <span class="material-icon icon-done"></span>
                </a>
              </template>
              <template v-else>
                <a href="#" @click.prevent="closeModal" class="btn btn-icon-right btn-success btn-shadow text-uppercase">
                  {{ $t('continue_order') }}
                  <span class="material-icon icon-keyboard_arrow_right"></span>
                </a>
                <a href="#" @click.prevent="closeCheckout" class="btn btn-link text-uppercase">
                  {{ $t('cancel_&_return_to_cart') }}
                </a>
              </template>
            </div>
          </div>`,
      }, {}, {...this.modalParams, maxWidth: 680});
    },
    showCloseOrderModal(reload = false) {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div class="custom-modal custom-modal--simple">
            <div class="custom-modal-content">
              <div class="custom-modal-content-inner">
                <p v-html="$t(isMobile ? 'cancel_order_text_mobile' : 'cancel_order_text')" :class="{'text-center': isMobile}"></p>
              </div>
            </div>
            <div class="custom-modal-footer">
              <template v-if="isMobile">
                <a href="#" @click.prevent="closeModal" class="btn btn-light btn-shadow">
                  <span class="material-icon icon-clear"></span>
                </a>
                <a href="#" @click.prevent="closeOrderModal(reload)" class="btn btn-success btn-shadow">
                  <span class="material-icon icon-done"></span>
                </a>
              </template>
              <template v-else>
                <a href="#" @click.prevent="closeModal" class="btn btn-icon-right btn-success btn-shadow text-uppercase">
                  {{ $t('continue_order') }}
                  <span class="material-icon icon-keyboard_arrow_right"></span>
                </a>
                <a href="#" @click.prevent="closeOrderModal(reload)" class="btn btn-link text-uppercase">
                  {{ $t('cancel') }}
                </a>
              </template>
            </div>
          </div>`,
        props: ['reload'],
      }, {reload}, {...this.modalParams, maxWidth: 680});
    },
    showMergeCartModal(cart) {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div class="custom-modal custom-modal--simple">
            <div class="custom-modal-content">
              <div class="custom-modal-content-inner">
                <h1>{{ $t('merge_shopping_cart') }}</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing?</p>
                <ul class="list-unstyled mt-4">
                  <li v-for="album in mergeAlbumItems" class="mb-4">
                    <p class="cart-album-title cart-album-title--small mb-2">
                        {{ album.album_title || $t('no_name') }}
                    </p>
                    <div class="cart-product mb-2" v-for="product in album.products">
                      <span class="cart-product-img" v-if="product.thumb_image"
                            :style="{backgroundImage: 'url(' + product.thumb_image + ')'}"></span>
                      <span v-else class="cart-product-no-img"></span>
                      <span class="cart-product-info">
                        <span class="cart-product-title">
                          {{ product.name }}
                        </span>
                        <span class="cart-product-description">
                          <template v-if="product.products">
                            {{ $tc('n_products', product.products.length, {amount: product.products.length}) }}
                          </template>
                          <template v-if="product.photos_quantity">
                            {{ $tc('n_photos', product.photos_quantity, {amount_total_photos: product.photos_quantity}) }}
                          </template>
                          <template v-if="product.snippet">,
                          {{ product.snippet }}</template>
                        </span>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="custom-modal-footer">
              <template v-if="isMobile">
                  <a href="#" @click.prevent="cancelMerge" class="btn btn-light btn-shadow">
                      <span class="material-icon icon-clear"></span>
                  </a>
                  <a href="#" @click.prevent="mergeCart(mergeAlbumItems)" class="btn btn-success btn-shadow">
                      <span class="material-icon icon-done"></span>
                  </a>
              </template>
              <template v-else>
                <a href="#" @click.prevent="mergeCart(mergeAlbumItems)" class="btn btn-success btn-shadow text-uppercase">
                  {{ $t('merge') }}
                </a>
                <a href="#" @click.prevent="cancelMerge" class="btn btn-link text-uppercase">
                  {{ $t('cancel') }}
                </a>
              </template>
            </div>
          </div>`,
        props: ['mergeAlbumItems'],
      }, {mergeAlbumItems: cart}, {...this.modalParams, maxWidth: 680});
    },
    showSecuredTagModal(tag = null, isMorePhotosSection = false) {
      this.blurBackground();

      this.$modal.show({
            template: `
        <div class="custom-modal custom-modal--simple">
          <div class="custom-modal-content">
            <div class="custom-modal-content-inner">
                <h1 class="text-center">{{ $t('private_gallery') }}</h1>
                <p class="text-center">{{ $t('descriptions.personal_albums') }}</p>
                <hidden-album-form class="mt-4"/>
            </div>
          </div>
          <div class="custom-modal-footer">
            <a v-if="isMobile" href="#" @click.prevent="closeModal" class="btn btn-light btn-shadow mr-auto">
              <span class="material-icon icon-clear"></span>
            </a>
            <a v-else href="#" @click.prevent="closeModal" class="btn btn-link text-uppercase">
              {{ $t('cancel') }}
            </a>
          </div>
        </div>`,
            props: ['tag', 'isMorePhotosSection'],
          }, {tag, isMorePhotosSection},
          {...this.modalParams, name: 'secured-tag', maxWidth: 660});
    },
    showCookieInformationModal() {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div class="custom-modal custom-modal--simple">
            <div class="custom-modal-content">
              <div class="custom-modal-content-inner">
                <h1>{{ $t('auth.cookie_info') }}</h1>
                <div v-html="$t('auth.cookie_info_description')"></div>
              </div>
            </div>
            <div class="custom-modal-footer">
              <a href="#" v-if="isMobile" @click.prevent="acceptCookies" class="btn btn-shadow btn-success" :class="{'btn-disabled btn-light': !album && this.$route.name === 'album'}">
                  <span class="material-icon icon-done"></span>
              </a>
              <a href="#" v-else @click.prevent="acceptCookies" class="btn btn-success btn-shadow btn-icon-right text-uppercase"> <!--:class="{'btn-disabled btn-light': !album && this.$route.name === 'album'}"-->
                {{ $t('accept_&_continue') }}
                <span class="material-icon icon-keyboard_arrow_right"></span>
              </a>
            </div>
          </div>`,
      }, {}, this.modalParams);
    },
    showNotificationsModal(amountPhotos, required) {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div>
            <div v-if="customerStep == 1" class="custom-modal">
              <div class="custom-modal-content additional">
                <div v-if="albumThumbnail" class="custom-modal-content--img"
                    :style="{backgroundImage: 'url(' + albumThumbnail + ')'}">
                </div>
                <div class="custom-modal-content-title">{{ $tc('n_photos', amountPhotos, {amount_total_photos: amountPhotos}) }}</div>
                <div class="custom-modal-content-subtitle" v-html="$t('notifications_description_1')"></div>
                <form @submit.prevent="customerStep = 2">
                  <div class="form-group">
                    <input v-model="customerName" type="text" class="form-control" placeholder="Name *" required>
                  </div>
                  <div class="form-group">
                    <input v-model="customerEmail" type="email" class="form-control" placeholder="E-Mail *" required>
                  </div>
                  <div class="form-group">
                    <input v-model="customerPhone" type="text" class="form-control" placeholder="Phone Number">
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <button type="submit" class="btn btn-success btn-shadow btn-icon-right mb-3 text-uppercase">
                       {{ $t('continue_to_album') }}
                      <span class="material-icon icon-keyboard_arrow_right"></span>
                    </button>
                    <a href="#" v-if="${required}" @click.prevent="backToGallery" class="btn btn-link text-uppercase">
                      {{ $t('cancel_&_close') }}
                    </a>
                    <a href="#" v-else @click.prevent="skipNotifications" class="btn btn-link text-uppercase">
                      {{ $t('skip') }}
                    </a>
                  </div>
                </form>
              </div>
            </div>
            <div v-if="customerStep == 2">
              <div class="custom-modal">
                <div class="custom-modal-content" :class="{'custom-modal-content--mobile': isMobile}">
                  <div class="custom-modal-content-inner">
                    <h1>{{ $t('notifications_confirmation') }}</h1>
                    <div class="custom-modal-content-subtitle" v-html="$t('notifications_description_2')"></div>
                  </div>
                </div>
                <div class="custom-modal-footer" :class="{'custom-modal-footer--mobile': isMobile}">
                  <button  @click="storeUserNotificationsData" class="btn btn-success btn-shadow btn-icon-right text-uppercase">
                    {{ $t('accept_&_continue') }}
                    <span class="material-icon icon-keyboard_arrow_right"></span>
                  </button>
                  <button  @click="customerStep = 3" class="btn btn-link text-uppercase ">
                    {{ $t('notifications_settings') }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="customerStep == 3">
              <div class="custom-modal">
                <div class="custom-modal-content" :class="{'custom-modal-content--mobile': isMobile}">
                  <div class="custom-modal-content-inner">
                    <h1>{{ $t('notifications_confirmation') }}</h1>
                    <div class="custom-modal-content-subtitle" v-html="$t('notifications_description_3')"></div>
                  </div>
                </div>
                <div class="custom-modal-footer" :class="{'custom-modal-footer--mobile': isMobile}">
                  <div class="custom-control custom-switch custom-switch-right w-100">
                    <input type="checkbox" class="custom-control-input"
                           v-model="allowNotifications" id="notify-me">
                    <label class="custom-control-label" for="notify-me">
                      <span>{{ $t('allow_notifications') }}</span>
                    </label>
                  </div>
                  <button  @click="storeUserNotificationsData" class="btn btn-success btn-shadow btn-icon-right text-uppercase">
                    {{ $t('accept_&_continue') }}
                    <span class="material-icon icon-keyboard_arrow_right"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
           `,
        props: ['amountPhotos'],
      }, {amountPhotos}, {...this.modalParams, maxWidth: 680});
    },
    showPrivateAlbumModal(privateKey) {
      this.blurBackground();

      this.$modal.hide('secured-tag');
      this.$modal.show({
        template: `
          <div class="custom-modal custom-modal--simple">
            <div class="custom-modal-content">
              <div class="custom-modal-content-inner">
                <h1 class="text-center">{{ $t('captcha_confirm') }}</h1>
                <p class="text-center">{{ $t('captcha_description') }}</p>
                <div class="captcha captcha--private-album">
                  <span v-if="!confirm && !isMobile"  class="helper helper--captcha" v-html="$t('click_on_this')"></span>
                  <vue-recaptcha :sitekey="recaptchaKey" @verify="verify" :loadRecaptchaScript="true"/>
                </div>
              </div>
            </div>
            <div class="custom-modal-footer">
                <template v-if="isMobile">
                    <a href="#" @click.prevent="closeModal" class="btn btn-light btn-shadow">
                        <span class="material-icon icon-clear"></span>
                    </a>
                    <a href="#" @click.prevent="goToPrivateAlbum(privateKey)" class="btn" :class="confirm ? 'btn-success btn-shadow' : 'btn-disabled'" :disabled="!confirm">
                        <span class="material-icon icon-done"></span>
                    </a>
                </template>
                <template v-else>
                    <a href="#" @click.prevent="goToPrivateAlbum(privateKey)" class="btn btn-icon-right text-uppercase" :class="confirm ? 'btn-success btn-shadow' : 'btn-disabled'" :disabled="!confirm">
                        {{ $t('confirm_&_continue') }}
                        <span class="material-icon icon-keyboard_arrow_right"></span>
                    </a>
                    <a href="#" @click.prevent="closeModal" class="btn btn-link text-uppercase">
                        {{ $t('cancel_&_close') }}
                    </a>
                </template>
            </div>
          </div>`,
        props: ['privateKey'],
      }, {privateKey: privateKey}, {...this.modalParams, maxWidth: 680});
    },
    showContactModal(form) {
      this.blurBackground();

      this.$modal.show({
        template: `
          <div class="custom-modal custom-modal--simple">
            <div class="custom-modal-content">
              <div class="custom-modal-content-inner">
                <h1 class="text-center">{{ $t('captcha_confirm') }}</h1>
                <p class="text-center">{{ $t('captcha_contact_description') }}</p>
                <div class="captcha captcha--private-album">
                  <span v-if="!confirm && !isMobile"  class="helper helper--captcha" v-html="$t('click_on_this')"></span>
                  <vue-recaptcha :sitekey="recaptchaKey" @verify="verify" :loadRecaptchaScript="true"/>
                </div>
              </div>
            </div>
            <div class="custom-modal-footer">
                <template v-if="isMobile">
                    <a href="#" @click.prevent="closeModal" class="btn btn-light btn-shadow">
                        <span class="material-icon icon-clear"></span>
                    </a>
                    <a href="#" @click.prevent="sendContactForm(form)" class="btn" :class="confirm ? 'btn-success btn-shadow' : 'btn-disabled'" :disabled="!confirm">
                        <span class="material-icon icon-done"></span>
                    </a>
                </template>
                <template v-else>
                    <a href="#" @click.prevent="sendContactForm(form)" class="btn btn-icon-right text-uppercase" :class="confirm ? 'btn-success btn-shadow' : 'btn-disabled'" :disabled="!confirm">
                        {{ $t('confirm_&_continue') }}
                        <span class="material-icon icon-keyboard_arrow_right"></span>
                    </a>
                    <a href="#" @click.prevent="closeModal" class="btn btn-link text-uppercase">
                        {{ $t('cancel_&_close') }}
                    </a>
                </template>
            </div>
          </div>`,
        props: ['form'],
      }, {form}, {...this.modalParams, maxWidth: 680});
    },
    closeWebsite() {
      window.open('', '_self').close();
      this.closeModal();
    },
    acceptCookies() {
      localStorage.setItem('cookies', '1');
      this.closeModal();

      /*if ((this.$route.name === 'album' || this.$route.name === 'tag') &&
          !localStorage.getItem('notify') &&
          this.album && +this.album.request_contact_data) {
        this.showNotificationsModal(this.album.total_pictures,
            +this.album.contact_data_required);
      }*/
    },
    skipNotifications() {
      localStorage.setItem(`notifyInfo-album-${this.album.id}`, '1');
      this.closeModal();
    },
    async storeUserNotificationsData() {
      const albumId = this.album.is_private
          ? `${this.album.hash}-${this.album.hash_password}`
          : this.album.id;

      const customerData = {
        name: this.customerName,
        email: this.customerEmail,
        phone: this.customerPhone,
        allow_notification: this.allowNotifications,
        album_id: albumId,
      };

      const loader = this.$loading.show();

      try {
        const response = await this.axios.post('v2/customer_contacts',
            customerData);

        if (response && response.data) {
          if (response.data.success) {
            this.toast(this.$t('success'), response.data.message, 'success');

            localStorage.setItem(`notifyInfo-album-${this.album.id}`,
                JSON.stringify(customerData));

            this.closeModal();
          } else if (response.data.message) {
            this.toast(this.$t('error'), response.data.message, 'danger');
          }
        }

        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    mergeCart(cart) {
      this.$store.dispatch('MERGE_PRODUCTS', cart);
      this.closeModal();
    },
    cancelMerge() {
      this.closeModal();
      this.axios.post('v2/cart', {
        payload: JSON.stringify(this.cart),
      });
    },
    backToGallery() {
      this.$router.push(this.i18nLink('gallery'));
      this.closeModal();
    },
    goToCheckout() {
      this.closeModal();
      this.$router.push(this.i18nLink('checkout'));
    },
    confirmAddress() {
      this.closeModal();

      const checkout = this.checkout;
      checkout.personalData = true;

      this.$store.commit('SET_CONFIRM_STREET_STATE', true);
      this.$store.dispatch('SET_CHECKOUT', checkout);
    },
    goToLoginCheckout() {
      this.closeModal();

      const checkout = this.checkout;
      checkout.authType = 'user';
      checkout.orderAsGuest = true;

      this.$store.dispatch('SET_CHECKOUT', checkout);
      this.$router.push(this.i18nLink('login'));
    },
    acceptSelectMoreInfo() {
      localStorage.setItem(`select-more-photos`, '1');
      this.closeModal();
    },
    continueAsGuest(order) {
      this.closeModal();
      this.checkoutAuthProcess(order);
    },
    closeCheckout() {
      this.closeModal();

      this.$store.dispatch('CLEAR_CHECKOUT');
      this.$store.dispatch('CLEAR_TMP_ORDER');
      this.$store.dispatch('SET_CHECKOUT_STEP', 1);

      if (localStorage.getItem('checkout')) {
        localStorage.removeItem('checkout');
      }

      this.$router.push(this.i18nLink('cart'));
    },
    closeOrderModal(reload = false) {
      if (this.uuid) {
        this.$router.push(this.i18nLink('cart'));
      } else if (!reload) {
        if (this.$store.getters.ORDER_FAVORITE_PHOTOS) {
          this.$store.dispatch('SET_ORDER_FAVORITE_PHOTOS', false);
          this.$router.push(this.i18nLink(`selected/${this.album.status === '2' ? `${this.album.hash}-${this.album.hash_password}` : this.album.id}`));
        } else if (this.$store.getters.SHOW_FAVORITE_PHOTO) {
          this.$store.dispatch('SET_SHOW_FAVORITE_PHOTO', false);
          this.$router.push(this.i18nLink(`selected/${this.album.status === '2' ? `${this.album.hash}-${this.album.hash_password}` : this.album.id}`));
        } else {
          this.$router.push(this.i18nLink(`album/gallery/${this.album.status === '2' ? `${this.album.hash}-${this.album.hash_password}` : this.album.id}${this.$store.getters.ALBUM_TAG ? `/tag/${this.$store.getters.ALBUM_TAG}` : ''}`));
          this.$nextTick(() => {
            const albumPhotos = this.albumPhotos;

            this.$store.dispatch('SET_ALBUM_PHOTOS', []);
            this.$store.dispatch('SET_ALBUM_PHOTOS', albumPhotos);
          });
        }
      }

      this.$store.dispatch('DROP_ORDER');

      if (reload) {
        this.$nextTick(() => {
          const albumPhotos = this.albumPhotos;

          this.$store.dispatch('SET_ALBUM_PHOTOS', null);
          this.$store.dispatch('LOADING_PHOTOS_BY_PARAMS', true);

          setTimeout(() => {
            this.$store.dispatch('SET_ALBUM_PHOTOS', albumPhotos);
            this.$store.dispatch('LOADING_PHOTOS_BY_PARAMS', false);
          }, 100);
        });
      }

      this.closeModal();
    },
    sendContactForm() {
      this.$store.dispatch('SET_CONTACT_FORM_CAPTCHA', this.recaptchaResponse);
      this.closeModal();
    },
    async goToPrivateAlbum(secretKey = null) {
      if (!secretKey) {
        secretKey = document.getElementById('hidden-album-input')
            ? document.getElementById('hidden-album-input').value
            : '';
      }

      const loader = this.$loading.show();

      try {
        const response = await this.axios.post('albums/get_private_album',
            {password: secretKey});

        if (response && response.data) {
          if (response.data.success && response.data.data) {
            this.closeModal();

            const data = response.data.data;

            if (data.view_type === 1 || data.view_type === 2 || data.view_type === 3) {
              let path;

              switch (data.view_type) {
                case 1:
                  path = this.i18nLink(`album/gallery/${data.hash}`);
                  break;
                case 2:
                  if (this.$route.name !== 'my-photos') {
                    path = this.i18nLink('my-photos');
                  }
                  break;
                case 3:
                  path = this.i18nLink(
                      `album/gallery/${data.album}/tag/${data.hash}`);
                  break;
              }

              if (path) {
                this.$router.push(path);
              }

              if (this.$route.name === 'album' || this.$route.name === 'tag') {
                this.reloadAlbum();
              }

              /*this.$nextTick(() => {
                this.$bvToast.toast(this.$t('messages.album_to_my_photos_added'), {
                    variant: 'success',
                    toaster: 'b-toaster-bottom-center',
                    toastClass: 'toast--lock-open',
                  });
              });*/

              switch (true) {
                case data.view_type === 2 && data.albums && data.albums.length > 0:
                  if (!this.user) {
                    data.albums.forEach((album) => {
                      const privateAlbum = {
                        album: album.hash,
                        hash: album.tag_url,
                        view_type: data.view_type
                      };

                      if (localStorage.getItem('syncPrivateAlbumsData')) {
                        let privateAlbums = JSON.parse(
                            localStorage.getItem('syncPrivateAlbumsData'));

                        if (!_.find(privateAlbums, {hash: privateAlbum.hash})) {
                          privateAlbums.push(privateAlbum);
                          this.$store.dispatch('ADD_CUSTOMER_ITEM', album);
                        }

                        localStorage.setItem('syncPrivateAlbumsData',
                            JSON.stringify(privateAlbums));
                      } else {
                        localStorage.setItem('syncPrivateAlbumsData',
                            JSON.stringify([privateAlbum]));
                        this.$store.dispatch('ADD_CUSTOMER_ITEM', album);
                      }
                    });
                  } else {
                    const privateAlbums = data.albums.map((album) => {
                      return {
                        album: album.hash,
                        hash: album.tag_url,
                        view_type: data.view_type
                      };
                    });

                    await this.axios.post('customers/add_private_albums',
                        {album_ids: privateAlbums});
                    this.$store.dispatch('INIT_CUSTOMER_ITEMS');
                  }

                  break;
                case data.view_type === 1 || data.view_type === 3:
                  if (!this.user) {
                    if (localStorage.getItem('syncPrivateAlbumsData')) {
                      let privateAlbums = JSON.parse(
                          localStorage.getItem('syncPrivateAlbumsData'));

                      if (!_.find(privateAlbums, {hash: data.hash})) {
                        privateAlbums.push(data);
                      }

                      localStorage.setItem('syncPrivateAlbumsData',
                          JSON.stringify(privateAlbums));
                    } else {
                      localStorage.setItem('syncPrivateAlbumsData',
                          JSON.stringify([data]));
                    }
                  } else {
                    await this.axios.post('customers/add_private_albums',
                        {album_ids: [data]});
                    this.$store.dispatch('INIT_CUSTOMER_ITEMS');
                  }
              }
            }
          } else {
            this.closeModal();
            this.toast(this.$t('error'), response.data.message, 'danger');
          }
        } else {
          this.closeModal();
          this.toast(this.$t('error'), this.$t('album_not_found'), 'danger');
        }
        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
        this.closeModal();
        this.toast(this.$t('error'), this.$t('album_not_found'), 'danger');
      }
    },
    verify(response) {
      if (response) {
        this.confirm = true;
        this.recaptchaResponse = response;
      }
    },
    selectMoreAnimation() {
      this.morePhotosExampleClasses = {1: '-hover', 2: '', 3: ''};

      setTimeout(() => {
        this.morePhotosExampleClasses = {1: '-checked', 2: '-hover', 3: ''};

        setTimeout(() => {
          this.morePhotosExampleClasses = {1: '-checked', 2: '-checked', 3: '-hover'};

          setTimeout(() => {
            this.morePhotosExampleClasses = {1: '', 2: '', 3: ''};
          }, 1000);
        }, 550);
      }, 550);
    },
    closeCouponModal() {
      this.showCouponBanner();
      this.closeModal();
    },
    closeModal() {
      this.confirm = false;

      this.$emit('close');
      this.unBlurBackground();
    },
  },
  created() {
    if (!localStorage.getItem(`select-more-photos`)) {
      this.selectMoreAnimation();

      setInterval(() => {
        this.selectMoreAnimation();
      }, 3500);
    }
  },
});
